
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import FileUpload from 'vue-upload-component'
import Scroll from '../../base/scollerView'
import {eventBus} from '../../../eventbus'
export default {
name: 'SubmitInformation',
components: {Group, XInput, Cell, XButton, PopupRadio, PopupPicker, Divider, FileUpload, Scroll},
data () {
return {
$vue: '',
username: '',
name: '',
sex: '',
idCard: '',
phone: '',
hospital: [],
title: '',
degree: '',
eMail: '',
eSignature: '',
eCertificate: '',
chooseESignature: '上传电子签名',
chooseECertificate: '上传执业证书',
eCertificateFiles: [],
eSignatureFiles: [],
picUploadUrl: '',
sexOptions: [
{
key: 1,
value: '男'
}, {
key: 2,
value: '女'
}
],
hospitalList: [],
titleOptions: [],
degreeOptions: [],
isShowLoading: false,
buttonText: '提交审核'
}
},
beforeMount () {
this.$vue = this
this.initPageInfo()
},
methods: {

initPageInfo () {
this.picUploadUrl = this.$vue.getData('UPLOAD_DOCTOR_INFO_PIC_URL')
this.phone = localStorage.getItem('PHONE')
this.getHospitalInfo()
this.getDicInfo()
},

getHospitalInfo () {
this.$http.get(this.$vue.getData('GET_ALL_HOSPITAL_NAME_ID')).then(response => {
if (response.data.result === '1') {
this.hospitalList.push(response.data.data)
} else {
alert('获取数据失败')
}
}).catch(err => {
console.log(err)
})
},

async getDicInfo () {
let params = new URLSearchParams()
params.append('types', 'ysxw,yszc')
let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
if (suc.data.result === '1') {
let titles = []
let degrees = []

suc.data.data.yszc.forEach((item) => {
let one = {
key: item.value,
value: item.key
}
titles.push(one)
})
suc.data.data.ysxw.forEach((item) => {
let one = {
key: item.value,
value: item.key
}
degrees.push(one)
})
this.titleOptions = titles
this.degreeOptions = degrees
}
},

filterInputFile (newFile, oldFile, prevent) {

if (newFile && !oldFile) {

if (!/\.(jpg|gif|png|jpeg)$/i.test(newFile.name)) {
AlertModule.show({
title: '图片类型错误',
content: '只能上传jpg、gif、png、jpeg格式的图片'
})
return prevent()
}

if ((newFile.size >= 0 && newFile.size < 100 * 1024) || newFile.size > 3 * 1024 * 1024) {
AlertModule.show({
title: '图片大小错误',
content: '图片应大于100kb，小于3M'
})
return prevent()
}

newFile.blob = ''
let URL = window.URL || window.webkitURL
if (URL && URL.createObjectURL) {
newFile.blob = URL.createObjectURL(newFile.file)
}
}

if (newFile && oldFile) {

}

if (!newFile && oldFile) {


}
},

inputFile (newFile, oldFile) {

let type
if (newFile.el.id === 'eCertificate') {
type = 1
} else if (newFile.el.id === 'eSignature') {
type = 2
}

if (newFile && !oldFile) {
}

if (newFile && oldFile) {

if (newFile.active !== oldFile.active) {

if (newFile.size >= 0 && newFile.size < 100 * 1024) {
AlertModule.show({
title: '错误',
content: '图片应该大于100kb，小于2M'
})
newFile = this.$refs.eCertificate.update(newFile, {error: '图片过小'})
}
}


if (newFile.progress !== oldFile.progress) {
console.log('progress', newFile.progress, newFile)
}


if (newFile.error !== oldFile.error) {
console.log('error', newFile.error, newFile)
this.handlerResponse(newFile.response, type)
}


if (newFile.success !== oldFile.success) {
console.log('success', newFile.success, newFile)
this.handlerResponse(newFile.response, type)
}
}

if (!newFile && oldFile) {

if (oldFile.success && oldFile.response.id) {




}
}

if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
if (type === 1) {
if (!this.$refs.eCertificate.active) {
this.$refs.eCertificate.active = true
}
} else if (type === 2) {
if (!this.$refs.eSignature.active) {
this.$refs.eSignature.active = true
}
}
}
},

handlerResponse (response, type) {
if (response.result === '1') {
if (type === 1) {
this.eCertificate = response.data[0]
this.chooseECertificate = '重新选择证书'
} else if (type === 2) {
this.eSignature = response.data[0]
this.chooseESignature = '重新选择签名'
}
} else {

AlertModule.show({
title: '图片上传失败',
content: '请尝试重新提交'
})
}
},
submitReview () {

this.$validator.validateAll().then((result) => {

if (!result) {
if (this.error.has('username')) {
eventBus.$emit('showToast', (this.error.first('username')))
return
}
if (this.error.has('name')) {
eventBus.$emit('showToast', (this.error.first('name')))
return
}
if (this.error.has('sex')) {
eventBus.$emit('showToast', (this.error.first('sex')))
return
}
if (this.error.has('idCard')) {
eventBus.$emit('showToast', (this.error.first('idCard')))
return
}
if (this.error.has('email')) {
eventBus.$emit('showToast', (this.error.first('email')))
return
}
if (this.error.has('hospital')) {
eventBus.$emit('showToast', (this.error.first('hospital')))
return
}
if (this.error.has('degree')) {
eventBus.$emit('showToast', (this.error.first('degree')))
return
}
if (this.error.has('title')) {
eventBus.$emit('showToast', (this.error.first('title')))
}
} else {

if (this.eCertificate === '') {
eventBus.$emit('showToast', '请上传执业证书')
return
}
if (this.eSignature === '') {
eventBus.$emit('showToast', '请上传电子签名')
}

this.submit()
}
})
},
async submit () {






this.isShowLoading = true
this.buttonText = '提交中...'

let params = new URLSearchParams()



params.append('NAME', this.name.toString())

params.append('SEX', this.sex.toString())

params.append('RID', this.idCard.toString())

params.append('EMAIL', this.eMail.toString())

params.append('hospitalId', this.hospital.toString())

params.append('docDegree', this.degree.toString())

params.append('docTitle', this.title.toString())

params.append('cmp', this.eCertificate.toString())

params.append('signature', this.eSignature.toString())
let suc = await this.$http.post(this.$vue.getData('SUBMIT_DOCTOR_INFO_URL'), params)
if (suc.data.result === '1') {

localStorage.removeItem('JWT_TOKEN')
localStorage.removeItem('ID')
localStorage.removeItem('PHONE')
this.$router.push({name: 'WaitReview'})
} else {
eventBus.$emit('showToast', suc.data.data)
}



}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/user/submitInformation.vue